//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
let d=[[],[[["objectType","searchType","searchText"],"PerformFind",{},3,0],[["partition","objectType","searchType","searchText"],"PerformFind1",{},4,0],[["objectType","searchType","criteriaTitles","criteriaValues"],"PerformFind2",{},4,0],[["nPartitions"],"GetPartitions",{R_:{partitions:"Assemblies.Partition[]"}},0,0],[["nSearchResultElements"],"GetSearchResultElements",{R_:{searchResultElements:"Assemblies.SearchResultElement[]"}},0,0]],[]];
SPLM.Assemblies.FindInCollaborativeDesign = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.FindInCollaborativeDesign";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.FindInCollaborativeDesign.ObjectType = Object.freeze({
    "Partition" : "Partition", "DesignElement" : "DesignElement", "RunElement" : "RunElement"});

SPLM.Assemblies.FindInCollaborativeDesign.SearchType = Object.freeze({
    "ItemQuery" : "ItemQuery"});

export default SPLM;